<template>
  <div id="app">
    <RouterView />

    <b-icon class="scroll_arrow" v-if="!$route.path.includes('auth')" :icon="icon" @click="onScroll(checkScrollStatus)"></b-icon>

    <Footer v-if="!$route.path.includes('auth')" />
  </div>
</template>
<script>
import Footer from './components/Footer.vue'
document.title = 'اینوآپ'
export default {
  data() {
    return {
      scrollStatus: true,
    }
  },
  components: { Footer },
  computed: {
    checkScrollStatus() {
      return this.scrollStatus ? true : false
    },

    icon() {
      return this.scrollStatus ? 'arrow-down' : 'arrow-up'
    },
  },
  methods: {
    onScroll(mode) {
      if (mode) {
        const bottom = document.body.scrollHeight
        window.scrollTo(0, bottom)
      } else window.scrollTo(0, 0)

      return (this.scrollStatus = !mode)
    },
  },
}
</script>
<style lang="scss">
@font-face {
  font-family: IranSans;
  src: url('./assets/fonts/IRANSansWeb2.ttf');
}
body,
html {
  padding: 0;
  margin: 0;
  text-align: right;
  direction: rtl;
  overflow-x: hidden;
  scroll-behavior: smooth;
}

* {
  font-family: 'IranSans' !important;
  box-sizing: border-box;
}

input {
  outline: none;
  border: none;
}

a {
  text-decoration: none !important;
}

.scroll_arrow {
  font-size: 50px !important;
  position: fixed !important;
  bottom: 20px;
  left: 20px;
  z-index: 2;
  padding: 8px;
  cursor: pointer;
  color: rgba(16, 29, 66, 1);
  background-color: rgba(255, 200, 51, 1);
}

@media (max-width: 540px) {
  .scroll_arrow {
    font-size: 40px !important;
  }
}
</style>
